import api from "@/core/api";

export const imagesRead = (owner: string) => api.query(`/images/list/${owner}`, { method: "get" });
